module.exports = __webpack_public_path__ + "img/hr-tree-09-a-leaves.86f2a9c3.png";